import React from "react";
import { Text, Card } from "@ifgengineering/component-library";
import {
  ChildrenWrapper,
  Container,
  DynamicTag,
  LogoTextContainer,
  StyledLogo,
  TitleDescription,
} from "./styled";
import noLogoImage from "@assets/cur8/img/no-logo-deal.png";
import { DealLabels } from "./renderDealLabels";
import { Commitment, Deal } from "@ifgengineering/client-invest-sdk";
import DateToExpire from "./components/DateToExpire.component";

type Props = {
  commitments: Commitment[];
  deal: Deal;
  dealLabels: DealLabels;
};

const DealCard: React.FC<Props> = ({ deal, commitments, dealLabels }) => {
  return (
    <Card elevation={1}>
      <ChildrenWrapper>
        <LogoTextContainer>
          <StyledLogo
            src={deal.investable?.displayImage?.url || noLogoImage}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = noLogoImage;
            }}
          />
          <TitleDescription>
            <Text type="T18" color="BLACK" fontFamily="archiamedium">
              {deal.name}
            </Text>
            <DynamicTag>{dealLabels.tags}</DynamicTag>
            <Text type="P16" color="SLATE900">
              {deal.description}
            </Text>
          </TitleDescription>
        </LogoTextContainer>
        <Container>{dealLabels.labels}</Container>
        <DateToExpire deal={deal} />
      </ChildrenWrapper>
    </Card>
  );
};

export default DealCard;
